<script lang="ts">
	import '$lib/notion-to-html/notion-colors.css';

	export let data: { content: string };
</script>

<div class="flex flex-col gap-3 pt-24 pb-16 x-wrapper">
	{#if data.content}
		{@html data.content}
	{/if}
</div>
